import(/* webpackMode: "eager" */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\bootstrap\\dist\\css\\bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "D:\\orion-nextjs\\orion-nextjs\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\src\\components\\HeaderFooterWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\src\\components\\ScrollTopButton\\ScrollTopButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\orion-nextjs\\orion-nextjs\\src\\components\\ScrollTopButton\\ScrollToTop.js");
;
import(/* webpackMode: "eager" */ "D:\\orion-nextjs\\orion-nextjs\\src\\styles\\CustomCss\\CustomStyle.css");
;
import(/* webpackMode: "eager" */ "D:\\orion-nextjs\\orion-nextjs\\src\\styles\\CustomCss\\Margins.css");
